import { Card, CardContent, Division, Flex, Skeleton, Span } from "@ir/ui";

interface DeductionActivitySkeletonProps {
  count: number;
}

const DeductionActivitySkeleton = ({ count = 5 }: DeductionActivitySkeletonProps) => {
  const loadingSkeletonList = new Array(count).fill(null);
  return (
    <Card className="bg-white">
      <CardContent className="p-0">
        <Flex direction="column" style={{ width: "100%" }} align="stretch" justifyContent="end" className="mb-0">
          {loadingSkeletonList.map((_, index) => (
            <Card key={index + "skeleton"} className="border-0">
              <CardContent className="py-2 px-0">
                <Flex justifyContent="space-between" className="mb-0">
                  <Flex align="center" gap={0.75}>
                    <Skeleton height={28} width={28} animation="wave" variant="rounded" radius={100} />
                    <Flex direction="column" gap={0.5}>
                      <Skeleton height={8} width={150} animation="wave" variant="rounded" />
                    </Flex>
                  </Flex>
                </Flex>
                <Flex direction="column" gap={1}>
                  <Division style={{ marginLeft: "40px" }}>
                    <Flex direction="column" wrap="wrap">
                      <Flex wrap="no-wrap">
                        <Span className="m-0 text-xs font-semibold text-grey-700 pe-1" style={{ minWidth: "130px" }}>
                          <Skeleton height={6} width={180} animation="wave" variant="rounded" />
                        </Span>
                        <Span className="ms-5 text-xs font-normal text-grey-600 d-flex flex-align-center" style={{ gap: "0.25rem" }}>
                          <Span>
                            <Skeleton height={6} width={130} animation="wave" variant="rounded" />
                          </Span>
                          <Span className="flex mx-2" style={{ fontSize: "18px", lineHeight: 1 }}>
                            ➝
                          </Span>
                          <Span>
                            <Skeleton height={6} width={130} animation="wave" variant="rounded" />
                          </Span>
                        </Span>
                      </Flex>
                    </Flex>
                    <Flex direction="column" wrap="wrap">
                      <Flex align="center">
                        <Skeleton height={6} width={180} animation="wave" variant="rounded" />
                      </Flex>
                    </Flex>
                  </Division>
                </Flex>
              </CardContent>
            </Card>
          ))}
        </Flex>
      </CardContent>
    </Card>
  );
};

export { DeductionActivitySkeleton };
